/**
 * Apply the Design System to a single Drupal behavior
 */
import { enableAllComponents } from '../../source/design-system';

import './scss/_drupal-styles.scss';

Drupal.behaviors.designSystem = {
  attach($context, settings) {
    if (window.MSInputMethodContext && document.documentMode) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '/themes/particle/dist/assets/ie11.js';
      script.addEventListener('load', () => {
        enableAllComponents($context, settings);
      });
      document.body.appendChild(script);
    } else {
      enableAllComponents($context, settings);
    }
  },
};
